/**
 * F-016 ship-dark switch (parked 2026-06-11): the deploy sets
 * VITE_COMPANION_ENABLED only when the environment's `features.companion`
 * flag is on. Parked bundles render the pre-F-016 UI byte-for-byte: no
 * NavigationReporter posts, no Related Sections rail, no live polling.
 */
export const companionEnabled = (): boolean => import.meta.env['VITE_COMPANION_ENABLED'] === 'true';
